import { Cache } from "aws-amplify";
const applicationServerPublicKey =
  "BKG3BFtJ9fNrgqMBSGWqR4VuBSYwde1zrptg1wn7HsdtY9QWYMPQ3iIFZTS3pINzMs6efMxnEfsgA8v7ECVfxQY";
let swRegistration = null;

export const handleSubscription = () => {
  function isSubscribed() {
    return swRegistration.pushManager
      .getSubscription()
      .then(function(subscription) {
        const isSubscribed = !(subscription === null);

        if (isSubscribed) {
          // console.log("User IS subscribed.");
          return true;
        }
        // console.log("User IS NOT subscribed.");
        return false;
      });
  }

  if ("serviceWorker" in navigator && "PushManager" in window) {
    console.log("Service Worker and Push is supported");

    return navigator.serviceWorker.ready.then(swReg => {
      // console.log(swReg);
      swRegistration = swReg;
      return isSubscribed();
    });
    // return navigator.serviceWorker
    //   .register("custom-service-worker.js")
    //   .then(swReg => {
    //     console.log("Service Worker is registered", swReg);
    //     swRegistration = swReg;
    //     return isSubscribed();
    //   })
    //   .catch(error => {
    //     console.error("Service Worker Error", error);
    //   });
  }
};

export const subscribeUser = () => {
  function urlB64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  /// Permiso para notificaciones
  function requestPermision() {
    return new Promise((resolve, reject) => {
      Notification.requestPermission(result => {
        resolve(result);
      });
    });
  }

  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

  return requestPermision().then(permissionResult => {
    switch (permissionResult) {
      case "granted":
        return swRegistration.pushManager
          .subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey
          })
          .then(subscription => {
            return {
              subscription: JSON.stringify(subscription),
              permissionResult
            };
          })
          .catch(err => {
            console.log("Failed to subscribe the user: ", err);
          });
      case "denied":
        return { subscription: null, permissionResult };
      default:
        return { subscription: null, permissionResult };
    }
  });
};

export const unsubscribeUser = () => {
  return swRegistration.pushManager
    .getSubscription()
    .then(subscription => {
      if (subscription) {
        Cache.setItem("subscription", JSON.stringify(subscription));
        return subscription.unsubscribe();
      }
    })
    .catch(error => {
      console.log("Error unsubscribing", error);
      return true;
    })
    .then(() => {
      return false;
    });
};



// WEBPACK FOOTER //
// ./src/webNotifications.js